import { generatePath, useHistory } from "react-router-dom";

import { ShiftCardWrapper } from "../../Shift/Card/Wrapper";
import { VisitCardContent } from "../Card/Content";
import { BOOKED_VISIT_DETAILS_FULL_PATH } from "../paths";
import { type PatientData, type VisitWithCaseData } from "../types";

interface InHomeBookedVisitCardProps {
  visit: VisitWithCaseData;
  patient: PatientData | undefined;
  specialties: string[];
  workplaceName: string;
}

export function InHomeBookedVisitCard(props: InHomeBookedVisitCardProps) {
  const { visit, patient, specialties, workplaceName } = props;
  const { attributes, id: visitId } = visit;
  const { caseId } = attributes;
  const history = useHistory();

  return (
    <ShiftCardWrapper
      onClick={() => {
        history.push(
          generatePath(BOOKED_VISIT_DETAILS_FULL_PATH, {
            caseId,
            visitId,
          })
        );
      }}
    >
      <VisitCardContent
        visit={visit}
        patient={patient}
        specialties={specialties}
        workplaceName={workplaceName}
      />
    </ShiftCardWrapper>
  );
}
